import api from '../services/api';

// Tanker Dashboard
export const getTankerDashboard = async () => {
  try {
    const response = await api.get('/tankers/dashboard');
    return response.data;
  } catch (error) {
    console.error('Error fetching tanker dashboard:', error);
    throw error;
  }
};

// Tanker Pricing
export const getTankerPricing = async () => {
  try {
    const response = await api.get('/tankers/pricing');
    return response.data;
  } catch (error) {
    console.error('Error fetching tanker pricing:', error);
    throw error;
  }
};

export const updateTankerPricing = async (pricingData) => {
  try {
    const response = await api.put('/tankers/pricing', pricingData);
    return response.data;
  } catch (error) {
    console.error('Error updating tanker pricing:', error);
    throw error;
  }
};

// Tanker Settings
export const getTankerSettings = async () => {
  try {
    const response = await api.get('/tankers/settings');
    return response.data;
  } catch (error) {
    console.error('Error fetching tanker settings:', error);
    throw error;
  }
};

export const updateTankerSettings = async (settingsData) => {
  try {
    const response = await api.put('/tankers/settings', settingsData);
    return response.data;
  } catch (error) {
    console.error('Error updating tanker settings:', error);
    throw error;
  }
};

// Tanker Users
export const getTankerUsers = async () => {
  try {
    const response = await api.get('/tankers/users');
    return response.data;
  } catch (error) {
    console.error('Error fetching tanker users:', error);
    throw error;
  }
};

export const createTankerUser = async (userData) => {
  try {
    const response = await api.post('/tankers/users', userData);
    return response.data;
  } catch (error) {
    console.error('Error creating tanker user:', error);
    throw error;
  }
};

export const updateTankerUser = async (id, userData) => {
  try {
    const response = await api.put(`/tankers/users/${id}`, userData);
    return response.data;
  } catch (error) {
    console.error('Error updating tanker user:', error);
    throw error;
  }
};

export const deleteTankerUser = async (id) => {
  try {
    const response = await api.delete(`/tankers/users/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting tanker user:', error);
    throw error;
  }
};

// Tanker Vehicles
export const getTankerVehicles = async () => {
  try {
    const response = await api.get('/tankers/vehicles');
    return response.data;
  } catch (error) {
    console.error('Error fetching tanker vehicles:', error);
    throw error;
  }
};

export const createTankerVehicle = async (vehicleData) => {
  try {
    const response = await api.post('/tankers/save_vehicle', vehicleData);
    return response.data;
  } catch (error) {
    console.error('Error creating tanker vehicle:', error);
    throw error;
  }
};

export const updateTankerVehicle = async (id, vehicleData) => {
  try {
    // Include vehicle_id in the data for the backend
    const response = await api.put(`/tankers/vehicles/${id}`, { ...vehicleData, vehicle_id: id });
    return response.data;
  } catch (error) {
    console.error('Error updating tanker vehicle:', error);
    throw error;
  }
};

export const deleteTankerVehicle = async (id) => {
  try {
    const response = await api.delete(`/tankers/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting tanker vehicle:', error);
    throw error;
  }
};

// Tanker Transactions
export const getTankerTransactions = async (params = {}) => {
  try {
    const response = await api.get('/tankers/transactions', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching tanker transactions:', error);
    throw error;
  }
};

export const deleteTankerTransaction = async (id) => {
  try {
    const response = await api.delete(`/tankers/transactions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting tanker transaction:', error);
    throw error;
  }
};

// Tanker Permits
export const getTankerPermits = async (min = null) => {
  try {
    const params = min ? { min } : {};
    const response = await api.get('/tankers/permits', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching tanker permits:', error);
    throw error;
  }
};

export const generateTankerPermits = async (permitData) => {
  try {
    const response = await api.post('/tankers/permits', permitData);
    return response.data;
  } catch (error) {
    console.error('Error generating tanker permits:', error);
    throw error;
  }
};

export const downloadTankerPermits = async (params = '') => {
  try {
    const response = await api.get(`/tankers/permits/download${params}`);
    return response.data;
  } catch (error) {
    console.error('Error downloading tanker permits:', error);
    throw error;
  }
};

// Tanker Reports
export const getTankerReports = async () => {
  try {
    const response = await api.get('/tankers/reports');
    return response.data;
  } catch (error) {
    console.error('Error fetching tanker reports:', error);
    throw error;
  }
};
